import { IPuzzle, ICell, IClue, CellType, ClueType, ArrowKeysSettings } from 'js/crossword/types';
import {
  getCurrentCell,
  getCurrentClue,
  getCluesWithCellIds,
  getCellAtPosition,
  isInBounds,
  getOtherDirectionClue,
} from 'js/crossword/puzzleDataHandlers/helpers';
import { getSettingsData } from 'js/crossword/settingsData';

export function handleArrowNavigation(puzzleData: IPuzzle, direction: [number, number]): [IClue, ICell] {
  const currentCell = getCurrentCell(puzzleData);
  const currentClue = getCurrentClue(puzzleData);
  const isVertical = direction[1] !== 0;

  // try to change clue direction without moving cell
  if (
    ((currentClue.type === ClueType.Across && isVertical) || (currentClue.type === ClueType.Down && !isVertical)) &&
    getSettingsData().arrowKeys === ArrowKeysSettings.Stay
  ) {
    const otherDirectionClue = getOtherDirectionClue(puzzleData);
    if (otherDirectionClue) {
      return [otherDirectionClue, currentCell];
    }
  }

  const nextCell = getNextRegularCellInDirection(puzzleData, direction, [currentCell.x, currentCell.y]);
  const clues = getCluesWithCellIds(puzzleData, nextCell.id);

  const clueWithSameDirection = clues.find((clue) => clue.type === currentClue.type);
  if (clueWithSameDirection) {
    return [clueWithSameDirection, nextCell];
  } else {
    return [clues[0], nextCell];
  }
}

function getNextRegularCellInDirection(
  puzzleData: IPuzzle,
  [offsetX, offsetY]: [number, number],
  [startX, startY]: [number, number],
): ICell {
  let currentX = startX;
  let currentY = startY;
  let currentCell = getCellAtPosition(puzzleData, startX, startY);

  while (true) {
    currentX += offsetX;
    currentY += offsetY;

    if (isInBounds(puzzleData, currentX, currentY)) {
      const cell = getCellAtPosition(puzzleData, currentX, currentY);
      if (cell.type === CellType.Regular) {
        currentCell = cell;
        break;
      }
    } else if (puzzleData.wrap) {
      const [x, y] = wrapPosition(puzzleData, currentX, currentY);
      currentX = x;
      currentY = y;
      const cell = getCellAtPosition(puzzleData, currentX, currentY);
      if (cell.type === CellType.Regular) {
        currentCell = cell;
        break;
      }
    } else {
      break;
    }
  }

  return currentCell;
}

function wrapPosition(puzzleData: IPuzzle, x: number, y: number): [number, number] {
  let wrappedX = x;
  let wrappedY = y;

  if (x >= puzzleData.columns) {
    // right
    wrappedX = 0;
    wrappedY = (y + 1) % puzzleData.rows;
  } else if (x < 0) {
    // left
    wrappedX = puzzleData.columns - 1;
    wrappedY = y - 1 >= 0 ? y - 1 : puzzleData.rows - 1;
  } else if (y >= puzzleData.rows) {
    // down
    wrappedX = (x + 1) % puzzleData.columns;
    wrappedY = 0;
  } else if (y < 0) {
    // up
    wrappedX = x - 1 >= 0 ? x - 1 : puzzleData.columns - 1;
    wrappedY = puzzleData.rows - 1;
  }

  return [wrappedX, wrappedY];
}

